// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerPageMatchCardOwnAnonymousAgent_agent_graphql = require("../../../__generated__/BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.bs.js");

let convertFragment = BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerPageMatchCardOwnAnonymousAgent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let agent = RescriptRelay_Fragment.useFragment(BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, props.agent);
  let match = agent.profilePhoto;
  let avatar = match !== undefined ? match.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
    avatar: avatar,
    size: size,
    name: agent.displayName,
    brokerage: agent.brokerage,
    wrapName: name => JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: `/agents/` + agent.id,
          onClick: e => {
            e.stopPropagation();
          },
          children: JsxRuntime.jsx("div", {
            children: name,
            className: "font-medium"
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs(ViewStack.make, {
            space: "zero",
            alignItems: "center",
            flexDirection: "row",
            children: [
              JsxRuntime.jsx("span", {
                children: "("
              }),
              JsxRuntime.jsxs(ViewStack.make, {
                space: {
                  NAME: "px",
                  VAL: "p5"
                },
                flexDirection: "row",
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    size: 12,
                    className: "text-zinc-500"
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Only visible to you"
                  })
                ]
              }),
              JsxRuntime.jsx("span", {
                children: ")"
              })
            ]
          }),
          className: "font-normal text-base text-zinc-500"
        })
      ],
      className: "flex flex-wrap gap-2"
    }),
    children: null
  });
}

let make = BuyerPageMatchCardOwnAnonymousAgent;

exports.Fragment = Fragment;
exports.make = make;
/* IconV5 Not a pure module */
